<template>
  <Layout style="height: 100%" class="main">
    <Sider
      hide-trigger
      collapsible
      :width="sure_width"
      :collapsed-width="0"
      v-model="collapsed"
      class="left-sider"
      :style="{ overflow: 'hidden' }"
    >
      <side-menu
        accordion
        ref="sideMenu"
        :openNames="openNames"
        :activeName="activeName"
        :menuMode="menuMode"
        :collapsed="collapsed"
        @on-select="turnToPage"
        :menu-list="menuList"
      >
        <!-- 需要放在菜单上面的内容，如Logo，写在side-menu标签内部，如下 -->
        <div class="logo-con public-pc-style"></div>
      </side-menu>
    </Sider>
    <Layout>
      <Header class="header-con" v-if="showChangeLanguage">
        <header-bar
          :collapsed="collapsed"
          @on-coll-change="handleCollapsedChange"
        >
          <user :message-unread-count="unreadCount" :user-avatar="userAvatar" />
        </header-bar>
      </Header>
      <Content class="main-content-con">
        <Layout class="main-layout-con">
          <!--
          <div class="tag-nav-wrapper">
            <tags-nav :value="$route" @input="handleClick" :list="tagNavList" @on-close="handleCloseTag"/>
          </div>
          -->

          <custom-bread-crumb
            show-icon
            class="crumb"
            :list="breadCrumbList"
            v-if="showChangeLanguage && getShowBreadCrumb"
          ></custom-bread-crumb>
          <Content class="content-wrapper scroll-box" id="contentTop">
            <keep-alive :include="cacheList">
              <router-view />
            </keep-alive>
            <ABackTop
              :height="100"
              :bottom="80"
              :right="50"
              container=".content-wrapper"
            ></ABackTop>
          </Content>
        </Layout>
      </Content>
      <!--<footer id="main-footer" class="text-center" v-if="showChangeLanguage">-->
      <!--<p class="inline-block">Copyright © 2018 StarChat International Limited.</p>-->
      <!--<Select v-model="aboutLanguage.languageType" class="inline-block" style="width: 80px;" @on-change="changeLan">-->
      <!--<Option v-for="item in aboutLanguage.languageArr" :value="item.value" :key="item.value">{{ item.label }}-->
      <!--</Option>-->
      <!--</Select>-->
      <!--</footer>-->
      <!-- 确认密码框 -->
      <PublicCheckPassword />
      <!-- 封禁输入名字校验输入框 -->
      <publicCheckBan />
    </Layout>
  </Layout>
</template>
<script>
import _ from "lodash";
import SideMenu from "./components/side-menu";
import HeaderBar from "./components/header-bar";
import TagsNav from "./components/tags-nav";
import User from "./components/user";
import ABackTop from "./components/a-back-top";
import Fullscreen from "./components/fullscreen";
import ErrorStore from "./components/error-store";
import customBreadCrumb from "@/components/main/components/header-bar/custom-bread-crumb/custom-bread-crumb";
import PublicCheckPassword from "@/components/publicCheckPassword/publicCheckPassword.vue";
import publicCheckBan from '@/components/publicCheckBan/publicCheckBan.vue';
import { mapMutations, mapActions, mapGetters } from "vuex";
import { getNewTagList, routeEqual } from "@/libs/util";
import routers from "@/router/routers";
import until from "@/js/until.js";

import "./main.less";
import log from "../../view/riskcontrolManagement/components/log";

export default {
  name: "Main",
  components: {
    SideMenu,
    HeaderBar,
    TagsNav,
    Fullscreen,
    ErrorStore,
    User,
    ABackTop,
    customBreadCrumb,
    PublicCheckPassword,
    publicCheckBan,
  },
  data() {
    return {
      pageVersion: 4, //强制刷新页面
      showChangeLanguage: false,
      version: until.environment() ? 11 : 16, //为修改版本号 菜单的version<=该值可以展示
      collapsed: false,
      isFullscreen: false,
      sure_width: this.getScreenIsSmall() ? document.body.offsetWidth : 200,
      menuMode: this.getScreenIsSmall() ? "horizontal" : "vertical",
      aboutLanguage: {
        languageType: this.$store.state.locale || "zh-cn",
        languageArr: [
          {
            value: "zh-cn",
            label: "中文",
          },
          {
            value: "en",
            label: "English",
          },
        ],
      },
      openNames: [],
      activeName: "",
    };
  },
  computed: {
    ...mapGetters(["errorCount", "getPublicSideMenu", "getLocale","getShowBreadCrumb"]),
    tagNavList() {
      return this.$store.state.app.tagNavList;
    },
    tagRouter() {
      return this.$store.state.app.tagRouter;
    },
    userAvatar() {
      return this.$store.state.user.avatarImgPath;
    },
    cacheList() {
      const list = [
        "ParentView",
        ...(this.tagNavList.length
          ? this.tagNavList
              .filter((item) => !(item.meta && item.meta.notCache))
              .map((item) => item.name)
          : []),
      ];
      return list;
    },
    menuList() {
      // 循环删除不显示side-menu-item，对应sideMenuItemHidden: true,
      if (!this.getPublicSideMenu.length) return [];
      let menuList = _.cloneDeep(this.$store.getters.menuList);
      // console.log(menuList, 158);
      let getFind = "";
      for (let i = 0; i < menuList.length; i++) {
        let listItem = menuList[i];
        if (listItem.meta) {
          const metaId = listItem.meta.id; //-1则一直会显示
          const metaVersion = listItem.meta.version; //修改版本号
          getFind = this.getPublicSideMenu.find(
            (sideMenuItem, sideMenuIndex) => {
              return sideMenuItem.id === metaId;
            }
          );

          if ((!getFind && metaId !== -1) || metaVersion > this.version) {
            // 本地执行的时候 -1则一直会显示
            menuList.splice(i, 1);
            i -= 1;
            // i = i - 1 < 0 ? -1 : i - 1; // -1循环后+1又重新变成0
            continue;
          }
        }
        // 执行到这都是有对应的权限的
        if (!listItem.children) break;
        let children = listItem.children;
        for (let j = 0; j < children.length; j++) {
          let childrenItem = children[j];
          if (
            childrenItem.meta &&
            (childrenItem.meta.sideMenuItemHidden ||
              childrenItem.meta.version > this.version)
          ) {
            children.splice(j, 1); // 不需要显示在侧边栏的则sideMenuItemHidden 为 true,
            j = j - 1 < 0 ? 0 : j - 1;
          }
        }
        // 判断是否有二级菜单权限
        if (children.length > 1){
          // 二级菜单>1是为了兼容只有一个一级菜单的children导致错乱
          let autharr = []
          for (let o = 0;o < children.length;o++){
            let childrenItem = children[o];
           // console.log(childrenItem)
            if (childrenItem.meta && childrenItem.meta.id){
              let auth = false
              if (typeof childrenItem.meta.id === 'number'){
                auth = this.getauth(childrenItem.meta.id)
              }
              if (childrenItem.meta.id.length > 0){
                let ids = childrenItem.meta.id
                for (let id = 0;id<ids.length;id++){
                  if (this.getauth(ids[id])){
                    auth = true
                    break
                  }
                }
              }
              if (auth){
                autharr.push(childrenItem.meta.id)
              }
            }
          }
           children = children.filter((e,i)=>{
           return autharr.includes(e.meta.id)
          })
        }
        // console.log(children)
        listItem.children = children;
      }

      // 有多级菜单的点击其父元素也能关闭下面的子元素，（原来只能通过点击其他地方来关闭）
      // setTimeout(() => {
      // this.$nextTick(() => {
      //   const ivuMenuSubmenu = document.querySelectorAll('.ivu-layout-sider .ivu-menu-submenu');
      //   ivuMenuSubmenu.forEach(elItem => {
      //     const elSubTitle = elItem.querySelector('.ivu-menu-submenu-title');
      //     elSubTitle && elSubTitle.addEventListener('click', () => {
      //       if (elItem.classList && elItem.classList.contains('ivu-menu-opened') && window.innerWidth < 760) {
      //         elItem.classList.remove('ivu-menu-opened');
      //         const elDropdown = elItem.querySelector('.ivu-select-dropdown');
      //         if (elDropdown) {
      //           elDropdown.style.display = 'none';
      //           setTimeout(() => {
      //             elDropdown.removeAttribute('x-placement');
      //           }, 300)
      //         }
      //       }
      //     });
      //   })
      // });
      // }, 24);
      // 如果是手风琴对应的页面则展开
      if (window.innerWidth >= 760) {
        this.openNames = this.getOpenName();
        this.$nextTick(() => {
          this.activeName = this.$route.name;
          this.$refs['sideMenu'].updateOpen();
        });
      }
      return menuList;
    },
    local() {
      return this.$store.state.app.local;
    },
    hasReadErrorPage() {
      return this.$store.state.app.hasReadErrorPage;
    },
    unreadCount() {
      return this.$store.state.user.unreadCount;
    },
    breadCrumbList() {
      return this.$store.state.app.breadCrumbList;
    },
  },
  methods: {
    ...mapMutations([
      "setBreadCrumb",
      "setTagNavList",
      "addTag",
      "setHomeRoute",
      "closeTag",
      "setpageNum",
      "settabNum",
    ]),
    ...mapActions(["handleLogin", "getUnreadMessageCount"]),
    turnToPage(route) {
      console.log(route)
      this.activeName = route;
      // 强制刷新页面
      var pageVersion = localStorage.getItem("pageVersion");
      if (Number(pageVersion) !== this.pageVersion) {
        localStorage.setItem("pageVersion", this.pageVersion);
        this.$router.go(0);
      }
      // if(this.activeName.length>1){
      //   this.openNames=[this.activeName[0]]
      // }else{
      //   this.openNames=[]
      // }

      // 点击目录页面参数初始化co
      this.setpageNum(1);
      localStorage.removeItem("tabNum");

      return;
      // 防止重复点击
      if (this.$route.name === route) return;
      let { name, params, query } = {};
      if (typeof route == "string") name = route;
      else {
        name = route.name;
        params = route.params;
        query = route.query;
      }
      if (name.indexOf("isTurnByHref_") > -1) {
        window.open(name.split("_")[1]);
        return;
      }

      this.$router.push({
        name,
        params,
        query,
      });

      // until.phoneType() == 'PC' ? '' : this.collapsed = true
      until.phoneType() == "PC" ? "" : (this.collapsed = false);
    },
    handleCollapsedChange(state) {
      this.collapsed = state;
    },
    handleCloseTag(res, type, route) {
      if (type !== "others") {
        if (type == "all") {
          this.turnToPage(this.$config.homeName);
        } else {
          if (routeEqual(this.$route, route)) {
            this.closeTag(route);
          }
        }
      }
      this.setTagNavList(res);
    },
    handleClick(item) {
      this.turnToPage(item);
    },
    handleScreen() {
      if (this.getScreenIsSmall()) {
        this.collapsed = false;
        this.menuMode = "horizontal";
        this.sure_width = document.body.offsetWidth;
      } else {
        this.collapsed = false;
        this.menuMode = "vertical";
        this.sure_width = 200;
      }
    },
    getScreenIsSmall() {
      if (window.innerWidth < 750) return true;
      return false;
    },
    changeLan(e) {
      this.$i18n.locale = e;
      this.$store.commit("SETLOCALE", e);
    },
    leftMenu() {
      if (this.getPublicSideMenu.length === 0) {
        this.$http
          .leftMenu("", {
            method: this.leftMenu,
            that: this,
          })
          .then((res) => {
            this.$store.commit("SETPUBLICSIDEMENU", res.data);
            // 设置鉴权列表
            var authList = [];
            res.data.forEach((item) => {
              authList.push(item.id)
              if (item.one_child_list && item.one_child_list.length > 0){
                item.one_child_list.forEach((ite) => {
                  authList.push(ite.id);
                  if (ite.two_child_list && ite.two_child_list.length > 0){
                    ite.two_child_list.forEach((it) => {
                      authList.push(it.id);
                    });
                  }

                });
              }

            });
            localStorage.setItem("authList", JSON.stringify(authList));
          });
      }
    },
    // 刚进入页面拿到openname，如果是手风琴页面则打开
    getOpenName() {
      try {
        let matched = this.$router.history.current.matched;
        matched = matched[0] || {};
        return [matched.name];
      } catch (e) {
        console.log(e);
        return [];
      }
    },
  },
  watch: {
    $route(newRoute) {
      const { name, query, params, meta } = newRoute;
      this.addTag({
        route: { name, query, params, meta },
        type: "push",
      });
      this.setBreadCrumb(newRoute);
      // this.setTagNavList(getNewTagList(this.tagNavList, newRoute))
      this.$refs.sideMenu.updateOpenName(newRoute.name);
    },
    getLocale: function () {
      // title翻译
      try {
        const $globalI18n = this.$selfGlobal.$globalI18n;
        document.title = $globalI18n.tc(
          this.$router.history.current.meta.nameText
        );
      } catch (e) {
        console.log(e);
        document.title = "admin";
      }
    },
  },
  created() {
    // console.log(this.$store.state.app.breadCrumbList);
    // console.log(this.getShowBreadCrumb)
    this.leftMenu();
    // 把国家列表请求到 保存到localStorage
    this.$http.findCountryList().then((res) => {
      if (Number(res.status) == 200) {
        localStorage.setItem("countriesList", JSON.stringify(res.data));
      }
    });
    // 把区域列表请求到 保存到localStorage
    this.$http.findregionSelectListByPage().then((res) => {
      if (Number(res.status) == 200) {
        res.data.push({id:0,text:'全部'})
        localStorage.setItem("interfaceRegional", JSON.stringify(res.data));
      }
    });
    if (until.phoneType() == "PC") {
      this.showChangeLanguage = true;
    } else {
      this.showChangeLanguage = false;
    }
  },
  mounted() {
    /**
     * @description 初始化设置面包屑导航和标签导航
     */
    // this.setTagNavList()
    this.setHomeRoute(routers);
    const { name, params, query, meta } = this.$route;
    this.addTag({
      route: { name, params, query, meta },
    });
    this.setBreadCrumb(this.$route);
    // 设置初始语言
    // 如果当前打开页面不在标签栏中，跳到homeName页
    if (!this.tagNavList.find((item) => item.name == this.$route.name)) {
      this.$router.push({
        name: this.$config.homeName,
      });
    }
    // 获取未读消息条数
    // this.getUnreadMessageCount()
    if (until.phoneType() != "PC") {
      // this.collapsed = true;
      this.collapsed = false;
      this.sure_width = document.body.offsetWidth;
    }

    this.$nextTick(() => {
      // this.handleScreen()
      until.screenResize(() => {
        this.handleScreen();
      });
    });
  },
};
</script>
<style lang="scss" scoped>
.crumb {
  padding: 10px 0 10px;
  margin-left: 30px;
}

/*@media screen and (max-width: 759px) {*/
  /*.main {*/
    /*display: block;*/
  /*}*/
  /*.left-sider > .ivu-menu-item,*/
  /*.left-sider > .ivu-menu-submenu {*/
    /*display: inline-block;*/
    /*float: none;*/
    /*&:last-of-type {*/
      /*margin-right: 20px;*/
    /*}*/
  /*}*/
  /*.left-sider > .ivu-menu {*/
    /*overflow: auto;*/
    /*white-space: nowrap;*/
  /*}*/

  /*.ivu-layout {*/
    /*// height: calc(100% - 60px);*/
    /*!*height: 100%;*!*/
    /*!*min-height: 400px;*!*/
  /*}*/

  /*.left-sider,*/
  /*.left-sider > .ivu-menu,*/
  /*.left-sider > .ivu-menu-submenu {*/
    /*position: static;*/
  /*}*/

  /*// 页脚移动端*/
  /*.main > .ivu-page-item:hover {*/
    /*border-color: #dcdee2;*/
    /*color: #515a6e;*/
  /*}*/
  /*.main > .ivu-page-item:hover a {*/
    /*color: #515a6e;*/
  /*}*/
  /*// menu移动端*/
  /*.main > .ivu-menu-dark.ivu-menu-horizontal .ivu-menu-item:hover,*/
  /*.main > .ivu-menu-dark.ivu-menu-horizontal .ivu-menu-submenu:hover {*/
    /*color: rgba(255, 255, 255, 0.7);*/
  /*}*/

  /*.main > .ivu-menu-dark.ivu-menu-horizontal .ivu-menu-item-selected {*/
    /*color: #ffffff !important;*/
  /*}*/

  /*.main > .ivu-select-dropdown .ivu-menu-drop-list .ivu-menu-item-selected {*/
    /*color: #515a6e !important;*/
  /*}*/
  /*.main > .ivu-page .ivu-page-item-active {*/
    /*border-color: #2d8cf0;*/
  /*}*/

  /*.main > .ivu-page .ivu-page-item-active a {*/
    /*color: #2d8cf0;*/
  /*}*/
/*}*/

@media screen and (max-width: 759px) {
  .main {
    display: block;
  }
  .left-sider  > > > .ivu-menu-item,
  .left-sider  > > > .ivu-menu-submenu {
    display: inline-block;
    float: none;
    &:last-of-type {
      margin-right: 20px;
    }
  }
  .left-sider  > > > .ivu-menu {
    overflow: auto;
    white-space: nowrap;
  }

  .ivu-layout {
    // height: calc(100% - 60px);
    height: 100%;
    min-height: 400px;
  }

  .left-sider,
  .left-sider  > > > .ivu-menu,
  .left-sider  > > > .ivu-menu-submenu {
    position: static;
  }

  // 页脚移动端
  .main > > > .ivu-page-item:hover {
    border-color: #dcdee2;
    color: #515a6e;
  }
  .main  > > > .ivu-page-item:hover a {
    color: #515a6e;
  }
  // menu移动端
  .main  > > > .ivu-menu-dark.ivu-menu-horizontal .ivu-menu-item:hover,
  .main  > > > .ivu-menu-dark.ivu-menu-horizontal .ivu-menu-submenu:hover {
    color: rgba(255, 255, 255, 0.7);
  }

  .main  > > > .ivu-menu-dark.ivu-menu-horizontal .ivu-menu-item-selected {
    color: #ffffff !important;
  }

  .main  > > > .ivu-select-dropdown .ivu-menu-drop-list .ivu-menu-item-selected {
    color: #515a6e !important;
  }
  .main  > > > .ivu-page .ivu-page-item-active {
    border-color: #2d8cf0;
  }

  .main  > > > .ivu-page .ivu-page-item-active a {
    color: #2d8cf0;
  }

  .header-con{
    display: none;
  }

}


#main-footer {
  padding: 10px 0;
}

.ivu-back-top-show {
  bottom: 150px !important;
  right: 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/main/main.vue